import { cn } from '../../utils/cn';

export function Skeleton({ className, ...props }) {
  return <div className={cn('skeleton-shimmer', className)} {...props} />;
}

/** Skeleton that matches a stat-card layout */
export function SkeletonCard() {
  return (
    <div className="bg-white rounded-2xl border border-surface-200/80 p-6 space-y-4">
      <Skeleton className="h-4 w-24 rounded" />
      <Skeleton className="h-8 w-40 rounded" />
      <div className="flex gap-3">
        <Skeleton className="h-12 w-20 rounded-xl" />
        <Skeleton className="h-12 w-20 rounded-xl" />
      </div>
    </div>
  );
}

/** Grid of skeleton cards */
export function SkeletonGrid({ count = 3, columns = 3 }) {
  return (
    <div className={cn('grid gap-6', columns === 3 && 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3', columns === 2 && 'grid-cols-1 md:grid-cols-2')}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

/** Rows of skeleton items (table-like) */
export function SkeletonRows({ count = 5 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 bg-white rounded-2xl p-4 border border-surface-200/80">
          <Skeleton className="h-10 w-10 rounded-full flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-36 rounded" />
            <Skeleton className="h-3 w-24 rounded" />
          </div>
          <Skeleton className="h-6 w-20 rounded-full" />
          <Skeleton className="h-5 w-28 rounded" />
        </div>
      ))}
    </div>
  );
}
